"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_TYPE = void 0;
var SESSION_TYPE;
(function (SESSION_TYPE) {
    SESSION_TYPE[SESSION_TYPE["ONLINE"] = 0] = "ONLINE";
    SESSION_TYPE[SESSION_TYPE["OFFLINE"] = 1] = "OFFLINE";
    SESSION_TYPE[SESSION_TYPE["HYBRID"] = 2] = "HYBRID";
})(SESSION_TYPE || (exports.SESSION_TYPE = SESSION_TYPE = {}));
